// Доступ к альфа-тесту: none → pending (заявка подана) → granted (одобрена).
// Отказа нет — заявка висит в pending, пока админ её не одобрит
export const EARLY_ACCESS = {
    none: 'none',
    pending: 'pending',
    granted: 'granted'
};

export const isEarlyAccessGranted = (status) => status === EARLY_ACCESS.granted;

export const isEarlyAccessPending = (status) => status === EARLY_ACCESS.pending;
